import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.seasonion) {
  enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  
  const direc =
  (environment.isMultiLanguageActive) && localStorage.getItem(environment.themeDirectionStorageKey)
    ? localStorage.getItem(environment.themeDirectionStorageKey)
    : environment.defaultDirection;
    

    if(direc == environment.defaultDirection){
      import('./assets/sass/style.angular.rtl.scss').then(x => {
        localStorage.setItem(environment.themeDirectionStorageKey, direc);
        platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
      }).catch(() => {
        localStorage.removeItem(environment.themeDirectionStorageKey);
        window.location.reload();
      });
    }else{
      import('./assets/sass/style.angular.scss').then(x => {
        localStorage.setItem(environment.themeDirectionStorageKey, direc);
        platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
      }).catch(() => {
        localStorage.removeItem(environment.themeDirectionStorageKey);
        window.location.reload();
      });
    }
    
      // if(direc == environment.defaultDirection){
      //   import('./assets/sass/style.angular.scss').then(x => {
      //     localStorage.setItem(environment.themeDirectionStorageKey, direc);
      //     platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
      //   }).catch(() => {
      //     localStorage.removeItem(environment.themeDirectionStorageKey);
      //     window.location.reload();
      //   });
      // }else{
      //   import('./assets/sass/style.angular.rtl.scss').then(x => {
      //     localStorage.setItem(environment.themeDirectionStorageKey, direc);
      //     platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
      //   }).catch(() => {
      //     localStorage.removeItem(environment.themeDirectionStorageKey);
      //     window.location.reload();
      //   });
      // }
  


